import { COUNTRY_DATA } from 'utils/constants'

const SUPPORTED_COUNTRIES = new Set(COUNTRY_DATA.map(({ value }) => value.toUpperCase()))

/** Whether `PhoneField` offers this ISO 3166-1 alpha-2 code (case-insensitive); restricted countries are left out. */
export const isSupportedCountry = (country: string) => SUPPORTED_COUNTRIES.has(country.toUpperCase())
